module.exports = __webpack_public_path__ + "img/basecam.233e8e11.png";